//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from "vant";
export default {
  data() {
    return {
      couponList:[],
      icrmDetail:{},
      productCode:'',
      loading:false,
      statet:'未使用'
    };
  },
  created() {
    this.getData();
    this.currentSize = this.$route.query.code.slice(-2);
    this.productCode= this.$route.query.code 
  },
  methods: {
    getData() {
      this.$toast.loading({
        message: "查询中",
        forbidClick: true,
        duration: 0,
      });
      let couponType = this.$route.query.code.length ==  18 ? 'icrm' : 'crm'
      this.axios
        .get(
          "/" +
            this.$ajaxPrefix.consumer +
            // "/api/v1/wx/cp/storestock/getStockQuery?matnr=" +
            "/v1/wx/cp/crmcoupon/getInfoByEcid?ecid=" +
            this.$route.query.code + "&couponType=" + couponType
        )
        .then((res) => {
          this.$toast.clear();
          if (res.data.code == 0) {
            if(couponType == 'crm'){
              var temp = res.data.data
              temp.forEach(item => {
                item.start_date = item.start_date.slice(0, 4) + '.' + item.start_date.slice(4, 6) + '.' + item.start_date.slice(6, 8);
                item.end_date = item.end_date.slice(0, 4) + '.' + item.end_date.slice(4, 6) + '.' + item.end_date.slice(6, 8);
                if (item.e_type.indexOf('ZK') > -1) {
                  item.flag = '折'
                  item.amount = parseFloat(item.balance_point);
                } else {
                  item.flag = '￥'
            
                  item.amount = parseInt(item.balance_point);
                }
                item.m_cost = parseFloat(item.m_cost);
                if (item.m_cost === 0) {
                  item.limit = '无门槛'
                } else {
                  item.limit = '满' + item.m_cost + '元使用'
                }
                item.point = parseFloat(item.point);
              });
              this.couponList=temp

              if(temp.length > 0 ){
                this.statet = temp[0].statet
              }else{
                this.statet = '没有查到优惠券'
              } 
            }else{
              if(res.data.data){
                let detail = res.data.data
                if(detail.template){
                  //券类型 01.贵宾券 02.订单券 03.商品券 04.内购券 05.折扣券 06.红包 07.津贴 08.储值券
                  switch (detail.template.couponType) {
                    case '01':
                      detail.e_typet = '贵宾券'
                      break;
                    case '02':
                      detail.e_typet = '订单券'
                      break;
                    case '03':
                      detail.e_typet = '商品券'
                      break;
                    case '04':
                      detail.e_typet = '内购券'
                      break;
                    case '05':
                      detail.e_typet = '折扣券'
                      break;
                    case '06':
                      detail.e_typet = '红包'
                      break;
                    case '07':
                      detail.e_typet = '津贴'
                      break;
                    case '08':
                      detail.e_typet = '储值券'
                      break;
                  }
                  if(detail.e_typet == '折扣券'){
                    detail.flag = '折'
                    detail.amount = parseInt(detail.template.discRate * 100);
                  }else{
                    detail.flag = '￥'
                    detail.amount = parseInt(detail.template.couponValue);

                  }
                  //hasThreshold 0无门槛 1有门槛 minAmount 门槛金额
                  switch (detail.template.hasThreshold) {
                    case '0':
                      detail.limit = '无门槛'
                      break;
                    case '1':
                      detail.limit = '满' + detail.template.minAmount + '元使用'
                      break;
                  }
                }
                detail.useStartDate = detail.useStartDate.slice(0, 10)
                detail.useEndDate = detail.useEndDate.slice(0, 10)
                this.icrmDetail = detail
                if(this.icrmDetail.used == 0){
                  this.statet = '未使用'
                }else if(this.icrmDetail.used == 1){
                  this.statet = '优惠券已使用'
                }else if(this.icrmDetail.used == 2){
                  this.statet = '优惠券已禁用'
                }else if(this.icrmDetail.used == 3){
                  this.statet = '优惠券已锁定'
                }else{
                  this.statet = '没有查到优惠券'
                }
              }else{
                this.statet = '没有查到优惠券'
                this.icrmDetail = {}
              }
              
            }
          } else {
             this.statet = '没有查到优惠券'
            // this.$toast({ message: "没有查到库存信息", duration: 2000 });
          }

        });
    },
        doVerifCoupon() {
          this.loading=true;
          this.$toast.loading({
            message: "查询中",
            forbidClick: true,
            duration: 0,
          });
          this.axios
            .get(
              "/" +
                this.$ajaxPrefix.consumer +
                "/v1/wx/cp/crmcoupon/destroy?ecid=" +
                this.productCode + "&couponType=" + (this.$route.query.code.length ==  18 ? 'icrm' : 'crm')
            )
            .then((res) => {
                this.loading=false;
              this.$toast.clear();
              console.log(res);
              if (res.data.code == 0) {
                this.statet = "已核销"
                // alert("成功");
                this.$toast({ message: '核销成功', duration: 2000 });
                this.$route.go(-1);
              } else {
                this.$toast({ message: res.data.msg, duration: 2000 });
              }
            });
        },
  },
  mounted() {
    document.title = "卡券核销";
  },
};
